var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable */
import axios from 'axios';
import * as Bowser from 'bowser';
import { v4 as uuidv4 } from 'uuid';
import { BigQueryError } from '../errors';
// 今後の分析データはlb_datasetというデータセットにためていくため、こちらを使うようにする。
const DEFAULT_DATASET_NAME = 'lb_dataset';
/**
 * CloudFunctionsに行動イベントを送信する
 * @class
 */
export class CloudFunctionClient {
    constructor(endpoint, authToken, localStorage) {
        Object.defineProperty(this, "endpoint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "authToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "os", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sessionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initialReferrer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "localStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axios.create();
        this.axios.interceptors.request.use((req) => {
            if (this.authToken) {
                const header = {
                    Authorization: authToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                };
                req.headers = Object.assign({}, req.headers, header);
            }
            return req;
        });
        this.axios.interceptors.response.use((res) => {
            return res;
        }, (error) => {
            this.onError(error);
        });
        this.authToken = authToken;
        this.endpoint = endpoint;
        this.localStorage = localStorage;
        this.setFixedParameters();
    }
    setReferrer() {
        if (!this.localStorage.loadStatsReferrer) {
            this.localStorage.saveReferrer(document.referrer);
        }
    }
    setInitialReferrer(initialReferrer) {
        if (!this.initialReferrer) {
            this.initialReferrer = initialReferrer;
        }
    }
    sendBqEvent(eventName, datasetName, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const param = new URLSearchParams();
            param.append('type', eventName);
            param.append('datasetName', datasetName);
            param.append('data', JSON.stringify(data));
            const res = yield this.axios.post(this.endpoint, param);
            return res.data;
        });
    }
    onError(error) {
        const e = error;
        if (!e.response) {
            throw e;
        }
        switch (e.response.status) {
            // 401のみ許容している
            case 401:
                console.log('Unauthorized.');
                break;
            // 503はsentryに送信しないようにエラーを返さないようにする
            case 503:
                console.log('Unavailable.');
                break;
        }
        throw e;
    }
    /*------ tracking ------*/
    /**
     * PVイベント
     * @param userId
     * @param sessionId
     */
    trackView(userId, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.userId) {
                this.userId = userId;
            }
            if (!this.sessionId) {
                this.sessionId = sessionId;
            }
            const params = Object.assign({}, this.commonParameters, {
                userId: userId,
                sessionId: sessionId,
                referrer: this.localStorage.loadStatsReferrer,
                initialReferrer: this.initialReferrer,
            });
            return yield this.sendBqEvent('views', 'views', params);
        });
    }
    /**
     * ビデオ再生イベントに再生時間などのオプションを付与。
     */
    trackVideoPlayStats(userId, isAutoPlay, stats) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, Object.assign({ userId: userId, sessionId: this.sessionId, isAutoPlay: isAutoPlay }, stats));
            return yield this.sendBqEvent('movie_play_stats', 'movie_play_stats', params);
        });
    }
    /**
     * ビデオ再生イベント
     * @param userId
     * @param stats
     */
    trackVideoPlay(userId, stats) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, Object.assign({ userId: userId, sessionId: this.sessionId }, stats));
            return yield this.sendBqEvent('movie_plays', 'movie_plays', params);
        });
    }
    /**
     * ビデオ一時停止イベント
     * @param userId
     * @param stats
     * @param time
     */
    trackVideoStop(userId, stats, time) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, Object.assign({ userId: userId, pauseTime: time, sessionId: this.sessionId }, stats));
            return yield this.sendBqEvent('movie_stops', 'movie_stops', params);
        });
    }
    /**
     * signupイベント
     * @param userId
     * @param email
     */
    trackSignUp(userId, email) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                id: userId,
                email: email,
                sessionId: this.sessionId,
                referrer: this.localStorage.loadStatsReferrer,
                initialReferrer: this.initialReferrer,
            });
            return yield this.sendBqEvent('users', 'users', params);
        });
    }
    /**
     * signinイベント
     * @param userId
     * @param email
     * @param authMethod
     */
    trackSignIn(userId, email, authMethod) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                userId: userId,
                email: email,
                authMethod: authMethod,
                sessionId: this.sessionId,
                referrer: this.localStorage.loadStatsReferrer,
                initialReferrer: this.initialReferrer,
            });
            return yield this.sendBqEvent('signin', 'signin', params);
        });
    }
    ccRegister(userId, ccRegisterParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const curPeriodEndTime = this.formatTimestampByClient(ccRegisterParams.curPeriodEndTime);
            const params = {
                id: uuidv4(),
                createdAt: this.reduceTimestamp(new Date().getTime()),
                userId: userId,
                trialStartTime: this.reduceTimestamp(new Date().getTime()),
                referrer: this.localStorage.loadStatsReferrer,
                cardLastFour: ccRegisterParams.cardLastFour,
                curPeriodEndTime: curPeriodEndTime,
                subPlanID: ccRegisterParams.subPlanId,
                trialEndTime: ccRegisterParams.trialEndTime,
                stripeCustomerId: '',
                initialReferrer: this.initialReferrer,
                CampaignCode: ccRegisterParams.campaignCode,
                reloclubKid: ccRegisterParams.reloclubKid,
            };
            return yield this.sendBqEvent('user_payments', 'user_payments', params);
        });
    }
    trackBecomeDormant() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                createdAt: this.formatTimestamp(),
                id: uuidv4(),
                sessionId: this.sessionId,
                user_id: this.userId,
            };
            return yield this.sendBqEvent('dormant_start', 'dormant_start', params);
        });
    }
    trackClickSearchPartCard(tagId) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                sessionId: this.sessionId,
                userId: this.userId,
                tagId: tagId,
            });
            return yield this.sendBqEvent('search_part_card_click', 'search_part_card_click', params);
        });
    }
    trackClickSearchStyleCard(styleID) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                sessionId: this.sessionId,
                userId: this.userId,
                styleID: styleID,
            });
            return yield this.sendBqEvent('search_style_card_click', 'search_style_card_click', params);
        });
    }
    trackSubmitSearch(word) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                sessionId: this.sessionId,
                userId: this.userId,
                word: word,
            });
            return yield this.sendBqEvent('search_word', 'search_word', params);
        });
    }
    trackClickSearchResultProgram(programID) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                sessionId: this.sessionId,
                userId: this.userId,
                programID: programID,
            });
            return yield this.sendBqEvent('search_result_program_click', 'search_result_program_click', params);
        });
    }
    trackClickSearchResultLesson(lessonID) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                sessionId: this.sessionId,
                userId: this.userId,
                lessonId: lessonID,
            });
            return yield this.sendBqEvent('search_result_lesson_click', 'search_result_lesson_click', params);
        });
    }
    trackFavoriteLesson(lessonId, status) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                sessionId: this.sessionId,
                userId: this.userId,
                lessonId: lessonId,
                status: status,
            });
            return yield this.sendBqEvent('favorite_lessons', 'favorite_lessons', params);
        });
    }
    trackFavoriteProgram(programId, status) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                sessionId: this.sessionId,
                userId: this.userId,
                programId: programId,
                status: status,
            });
            return yield this.sendBqEvent('favorite_programs', 'favorite_programs', params);
        });
    }
    trackReceivedBadge(badgeId, badgeName, badgeType) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                userId: this.userId,
                sessionId: this.sessionId,
                badgeId: badgeId,
                badgeName: badgeName,
                badgeType: badgeType,
            });
            return yield this.sendBqEvent('received_badges', 'received_badges', params);
        });
    }
    trackClickMatchingAssessmentStart() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                userId: this.userId,
                sessionId: this.sessionId,
            });
            return yield this.sendBqEvent('matching_assessment_start_clicks', 'matching_assessment_start_clicks', params);
        });
    }
    trackClickChallengeStart(programId, start, end) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                userId: this.userId,
                sessionId: this.sessionId,
                programId: programId,
                challengeStart: start,
                challengeEnd: end,
            });
            return yield this.sendBqEvent('challenge_start_clicks', 'challenge_start_clicks', params);
        });
    }
    trackClickUpdateChallengeStatus(programId, status, start, end) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                userId: this.userId,
                sessionId: this.sessionId,
                programId: programId,
                status: status,
                challengeStart: start,
                challengeEnd: end,
            });
            return yield this.sendBqEvent('challenge_update_status_clicks', 'challenge_update_status_clicks', params);
        });
    }
    trackClickPlanChange(plan, me) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                userId: this.userId,
                sessionId: this.sessionId,
                currentPlanId: me.payment.subPlanId,
                curPeriodEndDate: me.payment.curPeriodEndDate,
                trialEndDate: me.payment.trialEndTime && new Date(me.payment.trialEndTime),
                selectedQueuedPlanId: plan.stripePlanId,
                selectedQueuedPlanName: plan.name,
            });
            return yield this.sendBqEvent('plan_changes', 'plan_changes', params);
        });
    }
    trackClickRemovePlan(me) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                userId: this.userId,
                sessionId: this.sessionId,
                currentPlanId: me.payment.subPlanId,
                curPeriodEndDate: me.payment.curPeriodEndDate,
                trialEndDate: me.payment.trialEndTime && new Date(me.payment.trialEndTime),
                selectedQueuedPlanId: me.payment.subPlanId,
            });
            return yield this.sendBqEvent('plan_changes', 'plan_changes', params);
        });
    }
    trackHomeBannerClick(banner) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign({}, this.commonParameters, {
                sessionId: this.sessionId,
                userId: this.userId,
                bannerName: 'id: ' + banner.id,
                lessonId: banner.lessonId,
                programId: banner.programId,
                liveLessonId: banner.liveLessonId,
                announcementId: banner.announcementId,
                // NOTE: BQでlinkPathカラム削除したら、同名のカラムは7日間使用できなかったのでbaseLinkPathという名前にした
                baseLinkPath: banner.linkPath,
            });
            return yield this.sendBqEvent('home_banner_clicks', 'home_banner_clicks', params);
        });
    }
    trackPlayLiveVideo(liveUrl, liveTitle, startPositionTime) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const params = Object.assign(Object.assign({}, this.commonParameters), { userId: this.userId, sessionId: this.sessionId, liveUrl,
                    liveTitle,
                    startPositionTime });
                const res = yield this.sendBqEvent('live_video_plays', 'live_video_plays', params);
            }
            catch (err) {
                console.error(err);
            }
        });
    }
    trackOriginalPlaylistBannerClick(pageName) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign(Object.assign({}, this.commonParameters), { userId: this.userId, pageName });
            return yield this.sendBqEvent('original_playlist_banner_clicks', 'original_playlist_banner_clicks', params);
        });
    }
    trackOriginalPlaylistCreate() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign(Object.assign({}, this.commonParameters), { userId: this.userId });
            return yield this.sendBqEvent('original_playlist_create_clicks', 'original_playlist_create_clicks', params);
        });
    }
    trackFirstViewCarouselClick(linkPath) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign(Object.assign({}, this.commonParameters), { userId: this.userId, linkPath: linkPath });
            return yield this.sendBqEvent('first_view_carousel_clicks', 'first_view_carousel_clicks', params);
        });
    }
    trackFirstViewBannerClick(linkPath) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign(Object.assign({}, this.commonParameters), { userId: this.userId, linkPath: linkPath });
            return yield this.sendBqEvent('first_view_banner_clicks', 'first_view_banner_clicks', params);
        });
    }
    trackHomeClick(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign(Object.assign({}, this.commonParameters), { userId: this.userId, name: name });
            return yield this.sendBqEvent('home_clicks', DEFAULT_DATASET_NAME, params);
        });
    }
    trackInvitaionLinkCopy() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign(Object.assign({}, this.commonParameters), { userId: this.userId });
            return yield this.sendBqEvent('invitation_link_copy_clicks', DEFAULT_DATASET_NAME, params);
        });
    }
    trackSnsShareClick(snsParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign(Object.assign(Object.assign({}, this.commonParameters), { userId: this.userId }), snsParams);
            return yield this.sendBqEvent('sns_share_clicks', DEFAULT_DATASET_NAME, params);
        });
    }
    trackCancelUnsubscribeBannerClick() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign(Object.assign({}, this.commonParameters), { userId: this.userId });
            return yield this.sendBqEvent('cancel_unsubscribe_banner_clicks', DEFAULT_DATASET_NAME, params);
        });
    }
    trackUnsubscribeChatbotLogs(chatbotSessionId, sectionId, descriptionId, choiceId, inputData, nextSectionId, isStart, isUnsubscribeButtonClick) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign(Object.assign({}, this.commonParameters), { userId: this.userId, sessionId: chatbotSessionId, sectionId: sectionId, descriptionId: descriptionId, choiceId: choiceId, inputData: inputData, nextSectionId: nextSectionId, isStart: isStart, isUnsubscribeButtonClick: isUnsubscribeButtonClick });
            return this.sendBqEvent('unsubscribe_chatbot_logs', DEFAULT_DATASET_NAME, params);
        });
    }
    trackMypageProfileUpdate(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = Object.assign(Object.assign({}, this.commonParameters), { userId: this.userId, userName: profile.userName, birthday: profile.birthday, gender: profile.gender, prefecture: profile.prefecture, height: profile.height, weight: profile.weight, exerciseFrequencyType: profile.exerciseFrequency.name });
            yield this.sendBqEvent('mypage_profile_updates', DEFAULT_DATASET_NAME, params);
            // mypage_profile_updatesに紐づく「悩み」と「興味」のレコードも作成する
            const worryPromises = profile.worries.map((worry) => this.trackMypageProfileWorryUpdate(params.id, worry.id));
            const interestPromises = profile.interests.map((interest) => this.trackMypageProfileInterestUpdate(params.id, interest.id));
            yield Promise.all([...worryPromises, ...interestPromises]);
            return;
        });
    }
    trackMypageProfileWorryUpdate(mypageProfileUpdateId, worryId) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                id: uuidv4(),
                mypageProfileUpdateId: mypageProfileUpdateId,
                worryId: worryId,
                createdAt: this.formatTimestamp(),
            };
            return this.sendBqEvent('mypage_profile_worry_updates', DEFAULT_DATASET_NAME, params);
        });
    }
    trackMypageProfileInterestUpdate(mypageProfileUpdateId, interestId) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                id: uuidv4(),
                mypageProfileUpdateId: mypageProfileUpdateId,
                interestId: interestId,
                createdAt: this.formatTimestamp(),
            };
            return this.sendBqEvent('mypage_profile_interest_updates', DEFAULT_DATASET_NAME, params);
        });
    }
    trackClickMerchandise(merchandiseId) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                id: uuidv4(),
                merchandiseId,
                userId: this.userId,
                createdAt: this.formatTimestamp(),
            };
            return this.sendBqEvent('click_merchandise_logs', DEFAULT_DATASET_NAME, params);
        });
    }
    /*------ Private utilities ------*/
    setFixedParameters() {
        this.setOS();
    }
    get commonParameters() {
        return {
            browser: this.browser,
            id: uuidv4(),
            createdAt: this.formatTimestamp(),
            currentUrl: document.URL,
            os: this.os,
            ua: window.navigator.userAgent.toLocaleLowerCase(),
        };
    }
    get browser() {
        const ua = Bowser.parse(window.navigator.userAgent);
        const platform = ua.platform.type;
        return `${ua.browser.name}(${platform}) ${ua.browser.version}`;
    }
    // バンドルのjsのサイズを減らしたいのであえてmomentを使っていない
    // NOTE: BQ上ではUTCと表記されるがJSTです
    formatTimestamp() {
        const d = new Date();
        const y = d.getFullYear();
        const mon = this.numPadding(d.getMonth() + 1);
        const date = this.numPadding(d.getDate());
        const h = this.numPadding(d.getHours());
        const min = this.numPadding(d.getMinutes());
        const s = this.numPadding(d.getSeconds());
        return `${y}-${mon}-${date} ${h}:${min}:${s}`;
    }
    formatTimestampByClient(n) {
        const d = new Date(n);
        const y = d.getFullYear();
        const mon = this.numPadding(d.getMonth() + 1);
        const date = this.numPadding(d.getDate());
        const h = this.numPadding(d.getHours());
        const min = this.numPadding(d.getMinutes());
        const s = this.numPadding(d.getSeconds());
        return `${y}-${mon}-${date} ${h}:${min}:${s}`;
    }
    // jsデフォルトのstringPaddingが使えないブラウザがあるので自前定義
    numPadding(n) {
        return n < 10 ? `0${n}` : n;
    }
    setOS() {
        const ua = Bowser.parse(window.navigator.userAgent);
        this.os = `${ua.os.name}-${ua.os.version}`;
    }
    reduceTimestamp(n) {
        return parseInt(String(n / 1000));
    }
    checkError(response) {
        if (response.includes('FAILED'))
            throw new BigQueryError();
    }
}
